import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateBiometric,
    getDetailBiometricByUserId,
} from '../BiometricsEndPoint'

export const useDetailBiometricByUserId = (requestorId, userId) => {
    const {biometricsKeys} = QueryKeyManager(
        QueryKeyTypes.biometrics,
        requestorId,
    )
    return useQuery({
        queryKey: biometricsKeys.detailByUser({userId}),
        queryFn: () => getDetailBiometricByUserId(requestorId, userId),
        enabled: !!requestorId && !!userId,
    })
}

export const useBiometricCRUD = (type, requestorId) => {
    const {biometricsKeys} = QueryKeyManager(
        QueryKeyTypes.biometrics,
        requestorId,
    )
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateBiometric(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Biometrics Update Successfully !!',
                    )
                }
            }
        },
    })
}
